export default __webpack_public_path__ + "static/media/WIND.233b5e05.jpg";